export enum ANIMATED_ALERT_STATUS {
  OPEN = 'open',
  CLOSING = 'closing',
  CLOSED = 'closed',
}
